import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "row" }

import { defineAsyncComponent } from 'vue'

export default /*@__PURE__*/_defineComponent({
  __name: 'IndexToasts',
  setup(__props) {

const BasicToasts = defineAsyncComponent(() => import("@/components/theme/advance/toasts/BasicToasts.vue"))
const IconToasts = defineAsyncComponent(() => import("@/components/theme/advance/toasts/IconToasts.vue"))
const PositionToasts = defineAsyncComponent(() => import("@/components/theme/advance/toasts/PositionToasts.vue"))

return (_ctx: any,_cache: any) => {
  const _component_Breadcrumbs = _resolveComponent("Breadcrumbs")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Breadcrumbs, {
      main: "Bonus Ui",
      mains: "Toasts",
      title: "Toasts"
    }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_unref(BasicToasts)),
        _createVNode(_unref(IconToasts)),
        _createVNode(_unref(PositionToasts))
      ])
    ])
  ], 64))
}
}

})